import engagementProperties from 'automation-ui-references/transform/engagementProperties';
import { emptyPartition, genericFunnel, Matcher } from 'automation-ui-references/transform/transformGeneric';
import { filterMatch } from 'automation-ui-references/transform/objectFilters';
const toOption = engagementProperty => {
  const {
    label,
    value
  } = engagementProperty;
  return {
    text: label,
    value
  };
};
export const formatEngagementProperties = (propertyName = 'metadata.status') => {
  const matchedResults = genericFunnel(emptyPartition, [filterMatch(new Matcher({
    path: ['name'],
    value: propertyName
  }))], [], [], engagementProperties);
  const maybeProp = matchedResults[0];
  if (!maybeProp) {
    return [];
  }
  return genericFunnel(emptyPartition, [option => !option.hidden], [], [toOption], maybeProp.options);
};
export const getInitialPropertyValue = (propertyName = 'metadata.status') => {
  const options = formatEngagementProperties(propertyName);
  return options.length ? options[0].value : '';
};